import CustomSegment from '../../../../components/CustomSegment';
import PageTitle from '../../../../components/PageTitle';
import { useSegment } from '../../../../hooks/useSegment';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import type { SegmentedType } from '../../../../types/global.types';
import Filters from './_components/Filters';
import AppraisalReport from './AppraisalReport';
import KPISetUPReport from './KPISetUPReport';
import OpenKpiSetUp from './OpenKpiSetUp';
import Summary from './Summary';

export type PerformanceSegmentType =
  | 'emp-performance-summery'
  | 'emp-performance-open-kpi'
  | 'emp-performance-kpi-report'
  | 'emp-performance-appraisal-report';

export default function EmpPerformance() {
  const { segment, setSegment } = useSegment<PerformanceSegmentType>(
    'emp-performance-segment',
    'emp-performance-summery',
    true,
  );

  const SEGMENT_CONFIG: SegmentedType<PerformanceSegmentType>[] = [
    {
      value: 'emp-performance-summery',
      label: 'Summary',
      view: <Summary />,
    },
    {
      value: 'emp-performance-open-kpi',
      label: 'Open KPI Set-Up',
      view: <OpenKpiSetUp />,
    },
    {
      value: 'emp-performance-kpi-report',
      label: 'KPI Set-Up Report',
      view: <KPISetUPReport />,
    },
    {
      value: 'emp-performance-appraisal-report',
      label: 'Appraisal Report',
      view: <AppraisalReport />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Leave">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Performance Management"
        items={[
          { title: 'Dashboard', path: '/admin/employee/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />

      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
}
